<template>
<div class="container-fluid mb-4">
    <div class="row py-3">
            <div class="col-sm-12 col-md-6">
                <div class="text-left py-2">
                    <h3>Dashboard</h3>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker"
                    :ranges="false">
                    <template #input="picker" style="width: 100% !important;">
                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(dateRange.startDate) }}
                            - {{ FormatDate(picker.endDate) }}</p>
                        <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
                    </template>
                </date-range-picker>

            </div>
        </div>
        <hr />
        <div v-if="hasLoaded===true" class="card">
            <div class="card-body">
                <div class="row">
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-buildings"></i> Companies</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <p class="text-dark" ><span class="text-dark text-big"><i class="bi bi-circle-fill"></i></span> All - {{ companiesStats.activeCompanies.length + companiesStats.inActiveCompanies.length + companiesStats.freemiumCompanies.length }}</p>
                        <p class="text-dark" ><span class="text-success text-big"><i class="bi bi-circle-fill"></i></span> Subscribed - {{ companiesStats.activeCompanies.length}}</p>
                        <p class="text-dark" ><span class="text-warning text-big"><i class="bi bi-circle-fill"></i></span> On Trial - {{ companiesStats.freemiumCompanies.length}}</p>
                        <p class="text-dark" ><span class="text-danger text-big"><i class="bi bi-circle-fill"></i></span> Inactive - {{companiesStats.inActiveCompanies.length }}</p>


                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-cart-check-fill"></i> Orders & Transactions</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <p class="text-dark" >Completed Orders - {{ companiesStats.totalFinalOrderCount }}</p>
                        <p class="text-dark" >Payment Transactions - </p>
                        <p class="text-dark" >Services and Items Sold - </p>


                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-arrows-angle-contract"></i> Users</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />
                        <p class="text-dark" v-if="users.all"><span class="text-dark text-big"><i class="bi bi-circle-fill"></i></span> All Users - {{ users.all.length }}</p>
                        <p @click="showOnlineUsersModal" class="text-dark" ><span class="text-success text-big"><i class="bi bi-circle-fill"></i></span> Online - {{ users.active.length }} </p>


                    </div>
                </div>
            </div>
        </div>

            </div>

        </div>
        <div v-else class="card">
            <div class="card-body">
                <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
        <h2 class="pt-3">All Companies</h2>
         <form>
            <div class="form-group">
                <input class="form-control" v-model="companiesTable.searchTerm" placeholder="Search by company Name" />
            </div>
            </form>



        <b-table
        sticky-header="100vh"
        @filtered="onFiltered"
        :fields="companiesTable.fields"
        :items="filteredItems"
        :filter="companiesTable.filter"
        @row-clicked="onRowSelected"
        striped>
        <template #cell(is_active)="data">
  <div class="d-flex align-items-center">

    <div
      v-if="data.item.logo_url"
      class="rounded-circle d-flex justify-content-center align-items-center border"
      :class="data.item.is_active === 1 ? 'border-success' : 'border-danger'"
      style="width: 36px; height: 36px; overflow: hidden; border-width: 2px; !important"
    >
      <img
        :src="data.item.logo_url"
        alt="Logo"
        class="img-fluid rounded-circle"
        style="width: 100%; height: 100%; object-fit: cover;"
      />
    </div>

    <div
      v-else
      class="rounded-circle text-white fw-bold d-flex justify-content-center align-items-center"
      :class="data.item.is_active===1 ? 'bg-success' : 'bg-danger'"
      style="width: 36px; height: 36px;"
    >
      {{ getInitials(data.item.name) }}
    </div>
  </div>
</template>

            <template #cell(created_at)="data">
                {{ data.item.is_active }}
                {{formatDate(data.item.created_at, 'hh:mm A DD-MMM-Y')}}
            </template>
            <template #cell(due_date)="data">
                {{formatDate(data.item.billing.due_date, 'DD-MMM-Y')}}
            </template>
            <template #cell(last_activity)="data">
                <p>

                    {{(data.item?.user_activity_summary) ? formatDate(data.item.user_activity_summary.updated_at, 'hh:mm A DD-MMM-Y') : ''}}
                </p>
                <p><small>{{ (data.item?.user_activity_summary) ? data.item.user_activity_summary.logactivity.route : '' }}</small></p>

            </template>
            <template #cell(action)="data">
    <div class="dropup">
        <a data-toggle="dropdown" aria-expanded="false"><i class="bi bi-three-dots-vertical"></i></a>

        <div class="dropdown-menu">
            <a class="dropdown-item" :href='"/company-details?company-id=" + data.item.id'>More up Details</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="switchToViewAsOwner(data.item.id)" href="#">View as owner</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="changeBillingDateModal(data.item)">Adjust Billing Date</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="affiliateAssignModal(data.item)">Assign to Affiliate</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="markAsTest(data.item)">Mark as test</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="deleteCompanyConfirm(data.item)">Suspend</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" @click="deleteInventoryConfirm(data.item)">Delete Inventory</a>
        </div>
    </div>
</template>


        </b-table>
        <b-modal ref="online_users_modal" hide-footer>
            <h3 class="text-center py-2">Recent/Active Users</h3>

            <table class="table table-responsive w-100">
                <thead>
                    <tr>
                        <td>#</td>
                    <td>Name</td>
                    <td>Email</td>
                    <td>Company</td>
                    </tr>


                </thead>
                <tbody>
                    <tr v-for="user in users.active">
                        <td> # </td>
                        <td>{{ user.full_name ? user.full_name : user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.company.name }}</td>


                    </tr>
                </tbody>
            </table>
        </b-modal>

        <b-modal ref="affiliatesAssignModal" hide-footer>

            <div class="text-center">
                <h4>Assign {{ affiliateToAssign.company.name }} to an affiliate</h4>
                <form @submit.prevent="assignCompanyToAffiliate">
                <div class="form-group">
                    <p>Type name of affiliate below</p>
                    <input class="form-control" placeholder="Enter affiliate name" type="text" v-model="affiliateToAssign.affiliateCode"/>
                </div>

                <table class="table table-striped table-sm">
                    <tbody v-if="filteredAffiliate.length>0 && affiliateToAssign.affiliateCode !=='' ">
                        <tr @click="selectAffiliate(affiliate)" v-for="affiliate in filteredAffiliate">

                            <td>
                                <p class="text-capitalize text-left">{{ affiliate.affiliate_code }}</p>
                            </td>

                        </tr>
                    </tbody>
                </table>

                    <div class="form-group">
                        <select v-model="affiliateToAssign.package" class="form-control">
                        <option value="null" >Please Select package</option>
                        <option value="in-house" >Subscription only (In house)</option>
                        <option value="3000" >Kshs 3,000 Package</option>
                        <option value="5000" >Kshs 5,000 Package</option>
                        <option value="10000" >Kshs 10,000 Package</option>
                    </select>
                    </div>

                    <button class="btn btn-primary my-2" type="submit">Submit</button>
            </form>
            </div>

        </b-modal>
        <b-modal ref="changeDueDateModal" hide-footer>

            <div class="text-center">
               <h3>Change Billing Date</h3>
            <form @submit.prevent="changeBillingDate">
                <date-range-picker :auto-apply="autoApply" v-model="newDueDate" class="custom-width-datepicker"
               :single-date-picker="true" :ranges="false">
                    <template  #input="picker" style="width: 100% !important;">
                        <p v-if="newDueDate.startDate !==''">
                            {{formatDate(newDueDate.startDate, 'DD-MMM-Y')}}
                        </p>
                        <p v-else><i class="bi bi-calendar-event"></i> Select Date</p>
                    </template>

                </date-range-picker>
                <button class="btn btn-primary btn-block">Submit</button>
            </form>

            </div>

        </b-modal>
        <b-modal ref="changeSubscriptionPackageModal" hide-footer>

            <div class="text-center">
               <h3>Change Subscription plan</h3>
            <form @submit.prevent="changeSubscriptionPackage">
                <select class="form-control" v-model="selectedSubscriptionPlan">
                    <option value="null">Change Plan</option>
                    <option :value="plan.id" v-for="plan in subscriptionPlans">{{ plan.name }} | {{ plan.amount }}</option>
                </select>
                <button class="btn btn-primary btn-block">Submit</button>
            </form>

            </div>

        </b-modal>
        <b-modal size="lg" ref="companyDetails"  no-close-on-backdrop hide-footer>

            <div class="row">
                <div class="col-8">
                    <h3 class="text-left">

                {{ selectedCompany.name }}</h3>
                <p v-if="selectedCompany.user_activity_summary" class="text-success text-left"><i class="bi bi-circle-fill"></i>    Last activity date - {{ formatDate(selectedCompany.user_activity_summary.created_at, 'hh:mm A DD-MMM-Y') }}</p>
                <!-- <p v-else class="text-danger text-center"><i class="bi bi-circle-fill"></i>    Last activity date - {{ formatDate(selectedCompany.user_activity_summary.updated_at, 'hh:mm A DD-MMM-Y') }}</p> -->

                </div>
                <div class="col-4">
                    <div class="dropdown">
        <a class="btn btn-outline-secondary dropdown float-right" data-toggle="dropdown" aria-expanded="false">Actions</a>

        <div class="dropdown-menu">

            <a class="dropdown-item" @click="switchToViewAsOwner(selectedCompany.id)" href="#">View as owner</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="changeBillingDateModal(selectedCompany)">Adjust Billing Date</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="changeSubscriptionPackageModal(selectedCompany)">Change Subscription Plan</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="affiliateAssignModal(selectedCompany)">Assign to Affiliate</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="markAsTest(selectedCompany)">Mark as test</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="deleteCompanyConfirm(selectedCompany)">Suspend</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" @click="deleteInventoryConfirm(selectedCompany)">Delete Inventory</a>
        </div>
    </div>
                </div>
            </div>
            <div class="text-left">

            <hr />
            <h6>Basic Information</h6>
            <table class="table table-striped">
              <tr>
                <th>Industry</th>
                <td>{{ selectedCompany.industry }}</td>
              </tr>

              <tr>
                <th>Created At</th>
                <td>{{ formatDate(selectedCompany.created_at, 'hh:mm A DD-MMM-Y')}}</td>
              </tr>
              <tr>
                <th>Updated At</th>
                <td>{{formatDate(selectedCompany.updated_at, 'hh:mm A DD-MMM-Y') }}</td>
              </tr>
            </table>
        <div v-if="selectedCompany.billing">
            <h6>Billing Information</h6>
                    <table class="table table-striped border-0">
                    <tr>
                        <th>Plan Name</th>
                        <td>{{ selectedCompany.billing.subscriptionplan.name }}</td>
                    </tr>
                    <tr>
                        <th>Amount</th>
                        <td>{{ selectedCompany.billing.subscriptionplan.amount }}</td>
                    </tr>
                    <tr>
                        <th>Due Date</th>
                        <td>{{ selectedCompany.billing.due_date }}</td>
                    </tr>
                    </table>
        </div>

            <div v-if="selectedCompany.companysettings">
                <h6>Company Settings</h6>
                        <table class="table table-striped border-0">
                        <tr>
                            <th>Country</th>
                            <td>{{ selectedCompany.companysettings.country }}</td>
                        </tr>
                        <tr>
                            <th>Minimum Stock Alert</th>
                            <td>{{ selectedCompany.companysettings.minimums_stock }}</td>
                        </tr>
                        <tr>
                            <th>Enable Discounts</th>
                            <td>{{ selectedCompany.companysettings.enable_discounts ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Enable Taxes</th>
                            <td>{{ selectedCompany.companysettings.enable_taxes ? 'Yes' : 'No' }}</td>
                        </tr>
                        </table>
            </div>

            <div v-if="selectedCompany.user_activity_summary">
                <h6>Last Updated Route</h6>
                        <table class="table table-striped border-0">
                        <tr>
                            <th>Route</th>
                            <td>{{ selectedCompany.user_activity_summary.logactivity.route }}</td>

                        </tr>

                        </table>
            </div>
            <div v-if="selectedCompany.owner">
                <h6>Admin Details</h6>
                        <table class="table table-striped border-0">
                        <tr>
                            <th>Name</th>
                            <td>{{ selectedCompany.owner.name }}</td>

                        </tr>
                        <tr>
                            <th>Phone</th>
                            <td>{{ selectedCompany.owner.phone }}</td>

                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{{ selectedCompany.owner.email }}</td>

                        </tr>

                        </table>
            </div>
         <div v-if="selectedCompany.owner">
    <h6>Related Branches</h6>
    <table class="table table-striped border-0">
        <thead>
            <tr>
                <th>Name</th>
                <th>Billing plan</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="branch in selectedCompany.owner.companybranches"
                :key="branch.id"
                v-if="branch.company"
                @click="onRowSelected(branch.company)"
            >
                <td>{{ branch.company.name }}</td>
                <td>
                    {{ branch.company.billing?.subscriptionplan?.name }} -
                    {{ branch.company.billing?.subscriptionplan?.amount }}
                </td>
            </tr>
        </tbody>
    </table>
</div>

            <p>
  <a  data-toggle="collapse" href="#collapseCustomerfeedbackform" role="button" aria-expanded="false" aria-controls="collapseExample">
    <h6>Add Customer Feedback</h6>
  </a>

</p>
<div class="collapse" id="collapseCustomerfeedbackform">
    <div>

                        <form class="py-3" @submit.prevent="addCustomerFeedback">
                            <div class="form-group">
                                <label>Customer Name</label>

                                <input class="form-control" v-model="feedbackForm.feedbackName"/>
                            </div>
                            <div class="form-group">
                                <label>Email</label>

                                <input class="form-control" v-model="feedbackForm.feedbackEmail"/>
                            </div>
                            <div class="form-group">
                                <label>Phone</label>

                                <input class="form-control" v-model="feedbackForm.feedbackPhone"/>
                            </div>
                            <div class="form-group">
                                <label>What did the customer say</label>

                                <textarea v-model="feedbackForm.feedback" class="form-control"></textarea>
                            </div>
                            <div class="form-groupa">
                                <label>What type of Feedback ?</label>
                                <div class="form-check">
                                    <input v-model="feedbackForm.feedbackType" class="form-check-input" type="checkbox" id="complement"  value="complement" />
                                    <label class="form-check-label" for="complain">
                                        Complement
                                    </label>

                                </div>
                                <div class="form-check">
                                    <input v-model="feedbackForm.feedbackType" class="form-check-input" type="checkbox" id="complain"  value="complain" />
                                    <label class="form-check-label" for="complain">
                                      Complain
                                    </label>

                                </div>
                                <div class="form-check">
                                    <input v-model="feedbackForm.feedbackType" class="form-check-input" type="checkbox" id="feature"  value="feature" />
                                    <label class="form-check-label" for="complain">
                                        Feature suggestion
                                    </label>

                                </div>

                            </div>
                            <div class="form-group">
                                <button class="btn btn-outline-primary" type="submit">Submit</button>
                            </div>
                        </form>

            </div>
</div>





         </div>

        </b-modal>
<div class="mb-5"></div>

</div>
</template>
<script>
   import axios from "axios";
import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
import utils from "../../utils/utils";
import { result } from "lodash";
export default {
        name: "AdminDashboard",
        components: {
            DateRangePicker,
        },
        data() {
        return{
            autoApply: true,
            hasLoaded: false,
            companiesTable:{
                items:[],
                fields: [
                { key: 'is_active', label:'Status', sortable: false },
                { key: 'name', label:'Company', sortable: true ,filterByFormatted: true},
                { key: 'created_at', label:'Date Added', sortable: true },
                { key: 'due_date', label:'Billing Date', sortable: true },
                { key: 'last_activity', sortable: true },
                { key: 'action', label:'Action', sortable: false }
              ],
            filter: null,
            totalRows: 1,
            filterOn: [],
            searchTerm:'',
            },
            newDueDate:{
                startDate:''
            },
            dateRange: {
                    startDate: null,
                    endDate: null,
                },
            companies:{},
            users:{
                all:[],
                active:[]
            },
            affiliates:{},
            selectedCompany:{

                last_updated_at:{},
                // billing:{},
                // companysettings:{}
            },
            companyOwnerDetails:{},
            feedbackForm:{
                feedbackType:[],
                feedback:'',
                feedbackName:'',
                feedbackPhone:'',
                feedbackEmail:'',
            },
            companiesStats:{
                    companies:{
                        orders:{},
                        user:{},
                    },
                    activeCompanies:'',
                    inActiveCompanies:'',
                    freemiumCompanies:'',
                    allOrdersCount:'',
                    totalFinalOrderCount:'',


                },
                subscriptionPlans:{},
                selectedSubscriptionPlan:null,
                affiliateToAssign:{
                    package:null,
                    affiliate:'',
                    company:{},
                    affiliateCode:'',
                },
                affiliates:{
                    affiliate_code:''
                },




        }
    },
    mounted(){
        this.getAllCompaniesStats()
        this.getAllUsers()
        this.companiesTable.totalRows = this.companiesTable.items.length
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.companiesTable.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
        },

    filteredItems() {

      return this.companiesTable.items.filter(item =>


        item.name.toLowerCase().includes(this.companiesTable.searchTerm.toLowerCase())
      );
    },

    filteredAffiliate() {

        if (!Array.isArray(this.affiliates)) {


        return []; // or handle the error appropriately

             }

    return this.affiliates.filter(item =>

    item.affiliate_code ? item.affiliate_code.toLowerCase().includes(this.affiliateToAssign.affiliateCode.toLowerCase()) : ''
    );
    },

    },

    watch:{
        "affiliateToAssign.affiliateCode": function (before,after){
            if(this.affiliates.length < 1)
            {
                this.getAffiliates()
            }
        },

    },

    methods: {

       async getAllCompaniesStats()
       {
            await axios.get('/api/get-companies-stats').then(results=>{
                this.companiesStats = results.data
                const activeCompaniesArray = this.companiesStats.activeCompanies
                const allCompanies = activeCompaniesArray.concat(this.companiesStats.freemiumCompanies,this.companiesStats.inActiveCompanies)
                this.companiesTable.items = allCompanies
                this.hasLoaded=true


            }).catch(

            )
       },
        getInitials(name) {
  if (!name) return '';
  const words = name.split(' ');
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
},
       addCustomerFeedback()
    {
        axios.post('/api/customer-feedback',{
            ...this.feedbackForm,
            ...this.companyOwnerDetails,
            ...this.selectedCompany,
    }).then(results=>{

        }).catch(errors=>{})
    },
       selectAffiliate(affiliate)
       {
        this.affiliateToAssign.affiliate=affiliate
        this.affiliateToAssign.affiliateCode=affiliate.affiliate_code
        this.affiliates = {}
       },
       async getAllUsers()
       {
            await axios.get('/api/super/all-users').then(results=>{
                this.users = results.data


            }).catch(

            )
       },
       async changeBillingDate() {
        if(this.newDueDate.startDate !=='')
        {
            axios.post('/api/update-billing-due-date',{newDate:this.newDueDate.startDate,companyId:this.affiliateToAssign.company.id}).then(results=>
                {

                    if(results.status === 200)
                    {

                        this.newDueDate.startDate=''
                        this.$refs.changeDueDateModal.hide()
                    }
                }

            ).catch(error=>{

            })
        }
       },
       async changeSubscriptionPackage() {

           await axios.post('/api/update-subscription-plan',{plan:this.selectedSubscriptionPlan,companyId:this.affiliateToAssign.company.id}).then(results=>
                {

                    if(results.status === 200)
                    {


                        this.$refs.changeSubscriptionPackageModal.hide()
                    }
                }

            ).catch(error=>{

            })

       },
       async assignCompanyToAffiliate()
       {
            await axios.post('/api/assign-to-affiliate',{...this.affiliateToAssign}).then(results=>{

                if(results.status === 200)
                {
                    this.$toasts.push({
                     "message":results.data.message,
                     "type":results.data.type,
                    })
                }

            }).catch(

            )
       },
       async getAffiliates(){
        await axios.get('/api/affiliates').then(results=>{
                if(results.status === 200)
                {
                    this.affiliates = results.data

                }



            }).catch()
       },
       async affiliateAssignModal(item)
       {
                    this.getAffiliates()
                    this.affiliateToAssign.company = item

                    this.$refs.affiliatesAssignModal.show()
       },
       async changeBillingDateModal(item)
       {
                this.affiliateToAssign.company = item
                this.$refs.changeDueDateModal.show()
       },
       async changeSubscriptionPackageModal(item)
       {
                await axios.get('/api/all-subscription-plan').then(results=>{
                    this.subscriptionPlans = results.data
                }).catch(

            )
            console.log(item)
                this.affiliateToAssign.company = item
                this.$refs.changeSubscriptionPackageModal.show()
       },
       async showOnlineUsersModal()
       {
        this.getAllUsers()
        this.$refs.online_users_modal.show()
       },
       deleteInventoryConfirm(company)
       {
            this.boxTwo = ''
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete ' +  company.name + "'s inventory?" , {
            title: 'Delete Inventory',
            size: 'md',
            buttonSize: 'normal',
            okVariant: 'danger',
            okTitle: 'Confirm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                this.boxTwo = value
                if(value===true) this.deleteCompanyInventory(company.id)
            })
            .catch(err => {
                // An error occurred
            })

       },
       deleteCompanyConfirm(company)
       {
            this.boxTwo = ''
            this.$bvModal.msgBoxConfirm('Please confirm that you want to suspend ' +  company.name + "?" , {
            title: 'Suspend ' + company.name,
            size: 'md',
            buttonSize: 'normal',
            okVariant: 'danger',
            okTitle: 'Confirm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                this.boxTwo = value
                if(value===true) this.deleteCompany(company.id)
            })
            .catch(err => {
                // An error occurred
            })

       },
       markAsTest(company)
       {
            this.boxTwo = ''
            this.$bvModal.msgBoxConfirm('Please confirm that you want to mark/unmark this as test/ ' +  company.name + "?" , {
            title: company.name + ' - Mark/unmark as test',
            size: 'md',
            buttonSize: 'normal',
            okVariant: 'danger',
            okTitle: 'Confirm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                this.boxTwo = value
                if(value===true)
                axios.put('/api/company',{
                        company_id:company.id,
                        isDashboard:true,
                        is_test:(company.is_test===0) ? 1 :0
                    }).then(results=>{
                    if(results.status === 200)
                    {

                        this.$toasts.push(
                            {
                                type:'success',
                                message:'Company updated'
                            }
                        );
                        setTimeout(this.getAllCompaniesStats(),1000)

                    }
                }).catch()
            })
            .catch(err => {
                // An error occurred
            })

       },

       formatDate(date,format) {
                const finaldate = moment(date).format(format);
                return finaldate;
            },
            onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.companiesTable.totalRows = filteredItems.length
      },
      deleteCompanyInventory(companyId)
      {
        axios.post('/api/super/delete-company-inventory',{company_id:companyId}).then(results=>{
                    if(results.status === 200)
                    {

                        this.$toasts.push(
                            {
                                type:'success',
                                message:'Inventory deleted successfully'
                            }
                        );

                    }
                }).catch()
      },
      onRowSelected(items) {
    // Assign the selected company details first

        this.getCompanyDetails(items.id);
        this.$refs.companyDetails.show()
  },

    getCompanyDetails(companyId) {
         axios.get('api/company-full-details', { params: { company_id: companyId } })
          .then(response => {
            this.selectedCompany =  response.data

        })
          .catch(error => {
            throw error;
          });

    },
      deleteCompany(companyId)
      {
        axios.delete('/api/super/delete-company',{params:{id:companyId}}).then(results=>{
                    if(results.status === 200)
                    {

                        this.$toasts.push(
                            {
                                type:'success',
                                message:'Company Suspended'
                            }
                        );
                        setTimeout(this.getAllCompaniesStats(),1000)

                    }
                }).catch()
      },



      switchToViewAsOwner(companyId)
            {
                axios.get('/api/switch-branch?spadmin=1',{params:{companyId:companyId}}).then(results=>{
                    if(results.status === 200)
                    {
                        this.$store.commit('resetStore')

                        window.location.replace('/dashboard')

                    }
                }).catch()
            },
    },
}
</script>
